import { DatePicker, message, Modal } from "antd";
import { debtApi } from "api/debt.api";
import { useEffect, useState } from "react";
import { Debt } from "types/debt";
import dayjs, { Dayjs } from "utils/dayjs";
import { formatMoney } from "views/Opportunity/opportunity.meta";

type DebtUpdateModalProps = {
  debt: Debt | null;
  // "collect": xác nhận đã thu (nhập ngày thu); "due": sửa hạn thu
  mode: "collect" | "due";
  onClose: () => void;
  onDone: () => void;
};

export const DebtUpdateModal = ({ debt, mode, onClose, onDone }: DebtUpdateModalProps) => {
  const [date, setDate] = useState<Dayjs | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!debt) return;
    setDate(mode === "collect" ? dayjs() : debt.dueDate ? dayjs(debt.dueDate) : dayjs());
  }, [debt, mode]);

  const handleOk = async () => {
    if (!debt || !date) {
      message.warning(mode === "collect" ? "Chọn ngày thu" : "Chọn hạn thu");
      return;
    }
    setSaving(true);
    try {
      const value = date.format("YYYY-MM-DD");
      await debtApi.update(debt.id, mode === "collect" ? { collected: true, collectedDate: value } : { dueDate: value });
      message.success(mode === "collect" ? "Đã xác nhận thu" : "Đã cập nhật hạn thu");
      onDone();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={!!debt}
      title={mode === "collect" ? "Xác nhận đã thu" : "Sửa hạn thu"}
      okText={mode === "collect" ? "Xác nhận đã thu" : "Lưu"}
      cancelText="Hủy"
      confirmLoading={saving}
      onOk={handleOk}
      onCancel={onClose}
      destroyOnClose
    >
      {debt && (
        <div className="flex flex-col gap-3">
          <div className="text-sm text-gray-600">
            {debt.customer?.name || "--"} · {debt.order?.code || "--"} · {debt.content || "--"} ·{" "}
            <b>{formatMoney(debt.amount)}đ</b>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase text-gray-500 mb-1">
              {mode === "collect" ? "Ngày thu" : "Hạn thu"}
            </div>
            <DatePicker value={date} onChange={setDate} format="DD/MM/YYYY" allowClear={false} style={{ width: 220 }} />
          </div>
          {mode === "collect" && (
            <div className="text-xs text-gray-500">Công nợ sẽ chuyển sang "Đã thu" và không còn hiện ở menu này.</div>
          )}
        </div>
      )}
    </Modal>
  );
};
